import { render } from "./JobDetailHeader.vue?vue&type=template&id=0604971a&scoped=true"
import script from "./JobDetailHeader.vue?vue&type=script&lang=js"
export * from "./JobDetailHeader.vue?vue&type=script&lang=js"

import "./JobDetailHeader.vue?vue&type=style&index=0&id=0604971a&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0604971a"]])

export default __exports__